import styled from 'styled-components';

export const Title = styled.div``;

export const ItemsList = styled.ul`
    padding-left: 0.5rem;
`;

export const Item = styled.li<{
    tabbed?: boolean;
}>`
    margin: 0.5rem 0;
    margin-left: ${(props) => props.tabbed ? "2rem" : "1.5rem"};
`;

export const ItemLink = styled.a`
    color: black;
    font-weight: bold;
`;